<template>
  <main id="extension-request-main">
    <warehouse-list :action-str-mount-chained="actionMountChained" :action-str-select-chained="actionSelectChained" />
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('extensionRequest.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter" />
        </el-col>
      </el-row>

      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="8" class="default-section-title">
              {{ $t('extensionRequest.extensionsSummary') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>
<script>
import WarehouseList from '@/components/WarehouseList/WarehouseList';
import SearchFilter from './SearchFilters';
import SearchSummary from './SearchSummary';

export default {
  name: 'extensionRequest',
  components: {
    SearchFilter,
    SearchSummary,
    WarehouseList
  },
  data() {
    return {
      actionMountChained: ['extensionRequest/setDefaultFilters'],
      actionSelectChained: ['extensionRequest/search']
    };
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
#extension-request-main {
  .default-section-title {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>
